import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';

const StyledWarningGrid = styled(props => <Grid container {...props} />)(({ color, theme }) => ({
  color: color ? color : theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'noWrap',
  marginTop: '8px',
  '& span': {
    marginLeft: '8px',
  },
}));

export default StyledWarningGrid;
